import BaseModel from "./base/baseModel";
import TipoReceitaArquivo from "./enum/tipoReceitaArquivo";

export default class ReceitaArquivoModel extends BaseModel {
    id?: number = null;
    vendaId = 0;
    descricao: string = null;
    dataInclusao?: Date;
    tipo: TipoReceitaArquivo = TipoReceitaArquivo.Receita;
}
